import { useQuery } from '@hooks/reactQuery';

import { getRUStatusDashboardSynchronizationState } from '@api/ruStatusDashboard';

import { mapDropdownOptions } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { RU_DASHBOARD_SYNCHRONIZATION_STATE } from '@constants/queryKeys';

interface IUseQueryRUDashboardStatusSynchronizationState {
	ruDashboardStatusSynchronizationState: TSelectOption<string>[];
	isLoadingRUDashboardStatusSynchronization: boolean;
}

export const useQueryRUDashboardStatusSynchronizationState = (): IUseQueryRUDashboardStatusSynchronizationState => {
	const {
		data,
		isInitialLoading,
	} = useQuery({
		queryKey: [RU_DASHBOARD_SYNCHRONIZATION_STATE],
		queryFn: getRUStatusDashboardSynchronizationState,
		select: (data) => mapDropdownOptions({
			items: data,
			valueKey: 'name',
			labelKey: 'title',
		}),
		allowedRoles: [
			EUserRoles.smoLightUpdater,
			EUserRoles.smoLightViewer,
		],
		...refetchOptions,
	});

	return {
		ruDashboardStatusSynchronizationState: data || [],
		isLoadingRUDashboardStatusSynchronization: isInitialLoading,
	};
};
